import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Folder as FolderIcon } from '@mui/icons-material';
import DocumentViewer from './DocumentViewer';

const DocumentViewerButton = ({ invoice }) => {
  const [open, setOpen] = useState(false);

  // Add immediate console log
  console.log('DocumentViewerButton received invoice:', invoice);

  const handleOpen = () => {
    console.log('Opening viewer with invoice:', invoice);
    if (!invoice) {
      console.warn('No invoice provided to DocumentViewerButton');
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    console.log('Closing viewer');
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="">
        <IconButton size="small" onClick={handleOpen}>
          <FolderIcon />
        </IconButton>
      </Tooltip>

      <DocumentViewer 
        open={open}
        onClose={handleClose}
        invoice={invoice}
      />
    </>
  );
};

export default DocumentViewerButton;